<div class="container">
  <div class="m-1 p-2">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <mat-button-toggle-group name="fontStyle" aria-label="Font Style" (change)="selectionChange($event)">
        <mat-button-toggle value="all">All Events</mat-button-toggle>
        <mat-button-toggle value="Centre">Centre Events</mat-button-toggle>
      </mat-button-toggle-group>

      <mat-button-toggle-group [(ngModel)]="viewType">
        <mat-button-toggle value="calendar">
          <mat-icon>calendar_today</mat-icon>
        </mat-button-toggle>
        <mat-button-toggle value="cards">
          <mat-icon>view_module</mat-icon>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>

  <div class="row clearfix">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
      <div class="header d-flex justify-content-between">
        <h2>Events</h2>
        <div class="mb-3">
          <button mat-fab color="primary" permission="Events"
                  [permissionTypes]="[PermissionType.ALL, PermissionType.ADD]"
                  aria-label="Add new event" (click)="openCreateCenterDialog()">
            <mat-icon>add</mat-icon>
          </button>
        </div>
      </div>

      <!-- Calendar View -->
      <div *ngIf="viewType === 'calendar'" class="calendar-container mat-elevation-z2">
        <full-calendar [options]="calendarOptions"></full-calendar>
      </div>

      <!-- Card View -->
      <div *ngIf="viewType === 'cards'" class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <!-- Existing card view code -->
        <div class="body">
          <div class="demo">
            <div class="container">
              <div class="row">
                <div class="col-md-3 col-sm-6" *ngFor="let e of (events$ | async); let i = index">
                  <!-- ↓ inject the class here -->
                  <div class="pricingTable" [ngClass]="colorClasses[i % colorClasses.length]">
                    <div class="pricingTable-header">
                      <i class="material-icons">brightness_medium</i>
                      <div class="price-value status-text" (click)="openStatusModal(e, i)">
                        {{ e.status || 'Pending' }}
                      </div>
                    </div>
                    <h3 class="heading truncate-text capitalize" style="font-size:18px" [matTooltip]="e.eventName">{{ e.eventName }}</h3>
                    <div class="row mb-3">
                      <div class="col-md-6 mb-2">
                        <b>Date:</b> {{ e.eventDate.toDate() | date: 'dd/MM/yyyy' }}
                      </div>
                      <div class="col-md-6 mb-2">
                        <b>Time:</b> {{ e.eventTime.toDate() | date: 'shortTime' }}
                      </div>
                    </div>
                    <div class="pricing-content">
                      <ul>
                        <li><b>Event For:</b> {{ e.eventFor }}</li>
                        <li><b>Name:</b> {{ e.name }}</li>
                        <li><b>Email:</b> {{ e.email }}</li>
                        <li><b>Phone:</b> {{ e.number }}</li>
                        <li>
                          <b>Volunteer:</b>
                          <span *ngFor="let v of e.volunteer; let last = last">{{ v.name }}<span *ngIf="!last">, </span>
                          </span>
                        </li>
                      </ul>
                    </div>


                    <div class="pricingTable-signup">
                      <a permission="Events"
                         [permissionTypes]="[PermissionType.ALL, PermissionType.VIEW]"
                         class="btn btn-outline-primary btn-sm"
                         [routerLink]="['/home/Events', e.key]">VIVE PHOTOS</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Status Modal Template -->
<ng-template #statusModal>
  <h2 mat-dialog-title>Update Status</h2>
  <mat-dialog-content>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Select Status</mat-label>
      <mat-select [(value)]="selectedStatus">
        <mat-option value="Pending">Pending</mat-option>
        <mat-option value="Complete">Complete</mat-option>
        <mat-option value="Cancel">Cancel</mat-option>
      </mat-select>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button>Cancel</button>
    <button mat-flat-button color="primary" (click)="updateStatus()">Update</button>
  </mat-dialog-actions>
</ng-template>
